export var convertToEvent = function (event) { return event; };
